export default "__VITE_ASSET__D9LnmyVN__"